"use client";
import { Typography } from "antd";
import React from "react";

import CommentSymbolIcon from "@/app/icons/commentSymbolIcon";

import CommentSlider from "./commentSlider";

const OthersComments = () => {
  const { Title } = Typography;
  return (
    <div className="w-full !flex flex-col sm:flex-row gap-8 sm:items-center sm:justify-between bg-regal-blue-lighter p-4 xs:p-8">
      <div className="w-full sm:w-[45%] flex flex-col gap-4">
        <div className="w-14 h-14">
          <CommentSymbolIcon />
        </div>
        <Title level={2} className="H2">
          مشتریان ما
        </Title>
        <p className="text-regal-black-lighter ">
          صاحبان خانه‌ها، کارخانه‌های صنعتی، کشاورزان پیشرو و سرمایه‌گذاران
          آینده‌نگر برای کاهش هزینه‌ها و تولید انرژی پاک و کسب درآمد ما را
          انتخاب کرده‌اند.
        </p>
      </div>
      <div className="w-full bg-white sm:w-[55%] max-w-[32.125rem] h-60 rounded-lg shadow-multiShadow">
        <CommentSlider />
      </div>
    </div>
  );
};

export default OthersComments;
